import React from 'react';
import { ethers } from 'ethers';

function WalletLogin() {
    const loginWithWallet = async () => {
        if (!window.ethereum) return alert("Wallet not found");

        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const address = await signer.getAddress();

        const message = `Login request for ${address}`;
        const signature = await signer.signMessage(message);

        const res = await fetch('/api/auth/wallet-login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ message, signature })
        });

        if (res.ok) {
            const data = await res.json();
            localStorage.setItem('token', data.token);
            alert("Logged in with wallet!");
        } else {
            alert("Unauthorized");
        }
    };

    return <button onClick={loginWithWallet}>Login with Wallet</button>;
}

export default WalletLogin;
